import { navLinks, siteInfo } from '@/mocks/home';

export default function SiteFooter() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              {siteInfo.name}聚合今日明星、网红圈的最新黑料与爆料内容，覆盖吃瓜群众关心的热门事件，每日更新，快速找到你想看的线索与讨论。
            </p>
            <div className="mt-4 flex items-center gap-2 text-xs text-foreground-600">
              <span className="live-dot h-1.5 w-1.5 rounded-full bg-primary-500"></span>
              今日已更新 326 条爆料
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#index" className="cursor-pointer hover:text-primary-600">站内导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#index" className="cursor-pointer hover:text-primary-600">题材入口</a>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {['今日黑料', '明星黑料', '网红黑料', '爆料合集', '吃瓜榜单', '热点追踪'].map((t) => (
                <a
                  key={t}
                  href="#index"
                  className="cursor-pointer rounded-md border border-secondary-200 bg-secondary-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  {t}
                </a>
              ))}
            </div>
            <button
              type="button"
              onClick={scrollTop}
              className="mt-6 flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-arrow-up-line"></i>
              回到顶部
            </button>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name} · 内容仅供吃瓜娱乐参考</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>理性吃瓜 · 不信谣不传谣</span>
            <span>每日更新</span>
          </p>
        </div>
      </div>
    </footer>
  );
}